import {
    serializable,
    DynamicFormControlLayout,
    DynamicInputModel,
    DynamicInputModelConfig,
} from "@ng-dynamic-forms/core";
import { Model_WorkflowComponent, CODE_WORKFLOW_COMPONENT, TYPE_WORKFLOW_COMPONENT_OBSERVER, TYPE_DATASOURCE } from 'src/app/app.models';
import { COMPONENT_MODE } from '../../workflow-components.models';
import { WorkflowComponentBuilderOptions } from '../../workflow-components.service';

export enum BH_MOTIF_ABSENCE {
	PERMISSION = 'PERMISSION',
	CONGES = 'CONGES',
	FIN_MISSION = 'FIN_MISSION',
	MALADIE = 'MALADIE',
	DEMISSION = 'DEMISSION',
	MORT = 'MORT',
	MUTATION = 'MUTATION',
	ABANDON_MISSION = 'ABANDON_MISSION',
}

export const BH_MOTIF_ABSENCE_LABELS: {[key: string]: string} = {
    'PERMISSION': 'Permission',
    'CONGES': 'Congés',
    'FIN_MISSION': "Fin de mission",
    'MALADIE': "Maladie",
    'DEMISSION': "Démission",
    'MORT': "Mort",
    'MUTATION': "Mutation",
    'ABANDON_MISSION': "Abandon mission",
}

export const BH_MOTIF_ABSENCE_OPTIONS = [
	{ mVALUE_MEMBER: BH_MOTIF_ABSENCE.PERMISSION, mDISPLAY_MEMBER: BH_MOTIF_ABSENCE_LABELS[BH_MOTIF_ABSENCE.PERMISSION] },
	{ mVALUE_MEMBER: BH_MOTIF_ABSENCE.CONGES, mDISPLAY_MEMBER: BH_MOTIF_ABSENCE_LABELS[BH_MOTIF_ABSENCE.CONGES] },
	{ mVALUE_MEMBER: BH_MOTIF_ABSENCE.FIN_MISSION, mDISPLAY_MEMBER: BH_MOTIF_ABSENCE_LABELS[BH_MOTIF_ABSENCE.FIN_MISSION] },
	{ mVALUE_MEMBER: BH_MOTIF_ABSENCE.MALADIE, mDISPLAY_MEMBER: BH_MOTIF_ABSENCE_LABELS[BH_MOTIF_ABSENCE.MALADIE] },
	{ mVALUE_MEMBER: BH_MOTIF_ABSENCE.DEMISSION, mDISPLAY_MEMBER: BH_MOTIF_ABSENCE_LABELS[BH_MOTIF_ABSENCE.DEMISSION] },
	{ mVALUE_MEMBER: BH_MOTIF_ABSENCE.MORT, mDISPLAY_MEMBER: BH_MOTIF_ABSENCE_LABELS[BH_MOTIF_ABSENCE.MORT] },
	{ mVALUE_MEMBER: BH_MOTIF_ABSENCE.MUTATION, mDISPLAY_MEMBER: BH_MOTIF_ABSENCE_LABELS[BH_MOTIF_ABSENCE.MUTATION] },
	{ mVALUE_MEMBER: BH_MOTIF_ABSENCE.ABANDON_MISSION, mDISPLAY_MEMBER: BH_MOTIF_ABSENCE_LABELS[BH_MOTIF_ABSENCE.ABANDON_MISSION] },
];

export enum BH_MODE_SELECTION_SITE {
	SCANNER = 'SCANNER',
	DROPDOWN = 'DROPDOWN'
}
  
export interface BHQrCodeSiteScannerModelConfig extends DynamicInputModelConfig {
	componentMode: COMPONENT_MODE;
	modeSelectionSite: BH_MODE_SELECTION_SITE;
}
  
export class BHQrCodeSiteScannerModel extends DynamicInputModel {
	@serializable() readonly type: string = 'bh_qr_code_site_scanner';
	componentMode: COMPONENT_MODE;
	modeSelectionSite: BH_MODE_SELECTION_SITE;
	constructor(config: BHQrCodeSiteScannerModelConfig, layout?: DynamicFormControlLayout) {
		super(config, layout);
		this.componentMode = config.componentMode;
		this.modeSelectionSite = config.modeSelectionSite;
	}

	static initModel(_component: Model_WorkflowComponent): BHQrCodeSiteScannerModel {
		const formModel = new BHQrCodeSiteScannerModel({
			id: _component.ID,
			name: _component.ID,
			label: _component.LABEL,
			value: _component.DEFAULT_VALUE,
			required: _component.IS_REQUIRED,
			readOnly: _component.IS_READONLY,
			hidden: _component.IS_VISIBLE !== undefined ? _component.IS_VISIBLE === false : false,
			validators: _component.CUSTOM_VALIDATORS,
			componentMode: _component.COMPONENT_MODE,
            additional: _component,
			relations: _component.RELATIONS,
			modeSelectionSite: _component.BH_MODE_SELECTION_SITE ?? BH_MODE_SELECTION_SITE.SCANNER
		});
		return formModel;
	}

	static getProperties(_options?: WorkflowComponentBuilderOptions): Model_WorkflowComponent {
		return {
			ID: 'bh-qr-code-site-scanner',
			CODE: CODE_WORKFLOW_COMPONENT.BLACK_HAWK_SCAN_QRCODE_SITE,
			ICON: 'qr-code-outline',
			LABEL: '[BLACK-HAWK] Scan Site QRCode',
			HAS_DATASOURCE: true,
			DATASOURCES_INFOS: [
				{
					DS_PROP_ID: 'NUM_DATASOURCE_SITE',
					DS_PROP_VALUE_COLUMN_ID: 'QRCODE_DATASOURCE_SITE_COLUMN',
					DS_PROP_DISPLAY_COLUMN_ID: 'DISPLAY_DATASOURCE_SITE_COLUMN',
					DS_BUILD_NAME: 'DATASOURCE_SITE',
				},
			],
			PROPERTIES: [
				{ ID: 'GUID', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'GUID', IS_VISIBLE: false },
				{ ID: 'INDEX', CODE: CODE_WORKFLOW_COMPONENT.NUMERIC_TEXTBOX, LABEL: 'Index', DEFAULT_VALUE: 1 },
				{ ID: 'ID', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Identifiant', IS_REQUIRED: true, CUSTOM_VALIDATORS: [{ VALIDATOR_NAME: 'no_whitespace' }] },
				{ ID: 'LABEL', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Libellé', IS_REQUIRED: true },
				{ ID: 'IS_VISIBLE', CODE: CODE_WORKFLOW_COMPONENT.TOGGLE, LABEL: 'Est Visible ?', DEFAULT_VALUE: true },
				{ ID: 'IS_REQUIRED', CODE: CODE_WORKFLOW_COMPONENT.TOGGLE, LABEL: 'Est Requis ?' },
				{ ID: 'BH_MODE_SELECTION_SITE', CODE: CODE_WORKFLOW_COMPONENT.DROPDOWN, LABEL: 'Mode sélection site', DEFAULT_VALUE: BH_MODE_SELECTION_SITE.SCANNER, IS_REQUIRED: true, 
					UIC_PARAMS: {
						DATASOURCE: {
							DATASOURCE_TYPE: TYPE_DATASOURCE.STATIC,
							DATASOURCE_DATAS: [
								{ ID: BH_MODE_SELECTION_SITE.SCANNER, TEXT: 'Scan du code site' }, 
								{ ID: BH_MODE_SELECTION_SITE.DROPDOWN, TEXT: 'Selection du site' },
							],
							DATASOURCE_VALUE_FIELD: 'ID',
							DATASOURCE_DISPLAY_FIELD: 'TEXT'
						}
					}
				},
				{ ID: 'NUM_DATASOURCE_AGENT', CODE: CODE_WORKFLOW_COMPONENT.DATASOURCE_PICKER, LABEL: 'Agents', IS_REQUIRED: true, HAS_DATASOURCE_FILTERS: false },
                { ID: 'ID_DATASOURCE_AGENT_COLUMN', CODE: CODE_WORKFLOW_COMPONENT.DROPDOWN, LABEL: 'Identifiant Agent', IS_REQUIRED: true, 
					UIC_PARAMS: {
						OBSERVERS: [
							{ field: 'NUM_DATASOURCE_AGENT', type: TYPE_WORKFLOW_COMPONENT_OBSERVER.OBSERVE_DATASOURCE_STRUCTURE }
						],
						DATASOURCE: {
							DATASOURCE_TYPE: TYPE_DATASOURCE.STATIC,
							DATASOURCE_DATAS: [],
							DATASOURCE_VALUE_FIELD: 'value',
							DATASOURCE_DISPLAY_FIELD: 'display'
						}
					}
				},
                { ID: 'FULLNAME_DATASOURCE_AGENT_COLUMN', CODE: CODE_WORKFLOW_COMPONENT.DROPDOWN, LABEL: 'Nom & Prénoms Agent', IS_REQUIRED: true, 
					UIC_PARAMS: {
						OBSERVERS: [
							{ field: 'NUM_DATASOURCE_AGENT', type: TYPE_WORKFLOW_COMPONENT_OBSERVER.OBSERVE_DATASOURCE_STRUCTURE }
						],
						DATASOURCE: {
							DATASOURCE_TYPE: TYPE_DATASOURCE.STATIC,
							DATASOURCE_DATAS: [],
							DATASOURCE_VALUE_FIELD: 'value',
							DATASOURCE_DISPLAY_FIELD: 'display'
						}
					}
				},
				
				{ ID: 'NUM_DATASOURCE_SITE', CODE: CODE_WORKFLOW_COMPONENT.DATASOURCE_PICKER, LABEL: 'Sites', IS_REQUIRED: true, HAS_DATASOURCE_FILTERS: false },
                { ID: 'ID_DATASOURCE_SITE_COLUMN', CODE: CODE_WORKFLOW_COMPONENT.DROPDOWN, LABEL: 'Identifiant Site', IS_REQUIRED: true, 
					UIC_PARAMS: {
						OBSERVERS: [
							{ field: 'NUM_DATASOURCE_SITE', type: TYPE_WORKFLOW_COMPONENT_OBSERVER.OBSERVE_DATASOURCE_STRUCTURE }
						],
						DATASOURCE: {
							DATASOURCE_TYPE: TYPE_DATASOURCE.STATIC,
							DATASOURCE_DATAS: [],
							DATASOURCE_VALUE_FIELD: 'value',
							DATASOURCE_DISPLAY_FIELD: 'display'
						}
					}
				},
                { ID: 'QRCODE_DATASOURCE_SITE_COLUMN', CODE: CODE_WORKFLOW_COMPONENT.DROPDOWN, LABEL: 'QR Code Site', IS_REQUIRED: true, 
					UIC_PARAMS: {
						OBSERVERS: [
							{ field: 'NUM_DATASOURCE_SITE', type: TYPE_WORKFLOW_COMPONENT_OBSERVER.OBSERVE_DATASOURCE_STRUCTURE }
						],
						DATASOURCE: {
							DATASOURCE_TYPE: TYPE_DATASOURCE.STATIC,
							DATASOURCE_DATAS: [],
							DATASOURCE_VALUE_FIELD: 'value',
							DATASOURCE_DISPLAY_FIELD: 'display'
						}
					}
				},
				{ ID: 'DISPLAY_DATASOURCE_SITE_COLUMN', CODE: CODE_WORKFLOW_COMPONENT.DROPDOWN, LABEL: 'Libellé Site', IS_REQUIRED: true, 
					UIC_PARAMS: {
						OBSERVERS: [
							{ field: 'NUM_DATASOURCE_SITE', type: TYPE_WORKFLOW_COMPONENT_OBSERVER.OBSERVE_DATASOURCE_STRUCTURE }
						],
						DATASOURCE: {
							DATASOURCE_TYPE: TYPE_DATASOURCE.STATIC,
							DATASOURCE_DATAS: [],
							DATASOURCE_VALUE_FIELD: 'value',
							DATASOURCE_DISPLAY_FIELD: 'display'
						}
					}
				},
				{ ID: 'NUM_DATASOURCE_PLANNER', CODE: CODE_WORKFLOW_COMPONENT.DATASOURCE_PICKER, LABEL: 'Planning', IS_REQUIRED: true, HAS_DATASOURCE_FILTERS: false },
				
				{ ID: 'AGENTS', CODE: CODE_WORKFLOW_COMPONENT.INPUT_GRID_COLUMNS_BUILDER, LABEL: 'Agents', IS_VISIBLE: false, DEFAULT_VALUE: [
					{ ID: 'ID', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'ID Agent' },
					{ ID: 'FULLNAME', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Nom & Prénoms Agent' },
				] },
			]
		};
	}
}
  